import { Vertical } from './verticalService'
import { OgTag } from '../types/ogTag'

interface VerticalOgTag {
  imageUrl: string
  description: string
}

type VerticalOgTagType = { [key in Vertical]?: VerticalOgTag }

export const verticalOgTag: VerticalOgTagType = {
  DEPARTMENT: {
    imageUrl: 'https://ssl.pstatic.net/static.checkout/stylewindow/m/img/icon/department/snippet_image.png',
    description: '지금, 백화점 디스플레이 상품 그대로',
  },
  OUTLET: {
    imageUrl: 'https://ssl.pstatic.net/static.checkout/stylewindow/m/img/icon/outlet/snippet_image.png',
    description: '브랜드 상품을 가장 싸게 살 수 있는 방법',
  },
  STYLE: {
    imageUrl: 'https://ssl.pstatic.net/static.checkout/stylewindow/m/img/icon/style/snippet_image.png',
    description: '전국 구석구석 숨어있는 핫한 옷가게가 한눈에',
  },
  DESIGNER: {
    imageUrl: 'https://ssl.pstatic.net/static.checkout/stylewindow/m/img/icon/designer/snippet_image.png',
    description: '디자이너 전체보기',
  },
  BEAUTY: {
    imageUrl: 'https://ssl.pstatic.net/static.checkout/stylewindow/m/img/icon/beauty/snippet_image.png',
    description: '뷰티 꿀템과 꿀팁을 한곳에서!',
  },
  LIVING: {
    imageUrl: 'https://ssl.pstatic.net/static.checkout/stylewindow/m/img/icon/living/snippet_image.png',
    description: '골목골목 숨겨진 독특한 리빙 아이템이 한자리에',
  },
  FRESH: {
    imageUrl: 'https://ssl.pstatic.net/static.checkout/stylewindow/m/img/icon/fresh/snippet_image.png',
    description: '전국산지 생산자의 식재료부터 지역명물,전통주, 쿠킹박스까지 한눈에',
  },
  KIDS: {
    imageUrl: 'https://ssl.pstatic.net/static.checkout/stylewindow/m/img/icon/kids/snippet_image.png',
    description: '엄마들에게 입소문 난, 깐깐한 육아 상품들이 모여있는 곳',
  },
  PET: {
    imageUrl: 'https://ssl.pstatic.net/static.checkout/stylewindow/m/img/icon/pet/snippet_image.png',
    description: '소중한 나의 펫을 위한 맞춤 쇼핑 공간',
  },
  PLAY: {
    imageUrl: 'https://ssl.pstatic.net/static.checkout/stylewindow/m/img/icon/play/snippet_image.png',
    description: '스포츠용품부터 레어템까지 핫한 상품을 한눈에',
  },
  ART: {
    imageUrl: 'https://ssl.pstatic.net/static.checkout/stylewindow/m/img/icon/art/snippet_image.png',
    description: '온라인에서 즐기는 쉽고 편한 갤러리',
  },
  FOREIGN: {
    imageUrl: 'https://ssl.pstatic.net/static.checkout/stylewindow/m/img/icon/foreign/snippet_image.png',
    description: '해외 유명상품을 가장 쉽고 빠르게 쇼핑하는 방법',
  },
  GIFT: {
    imageUrl: 'https://ssl.pstatic.net/static.checkout/cnsv/m/im/ogtag/14_gift_1.png',
    description: '백화점 상품부터 e쿠폰까지 마음을 전하는 방법, 선물',
  },
}

export const myOgTag: OgTag = {
  title: '네이버쇼핑 쇼핑MY',
  imageUrl: 'https://ssl.pstatic.net/static.checkout/cnsv/m/im/snippet/snippet_shopping.png',
  description: '찜한상품, 스토어찜, 톡톡친구, Q&A를 쇼핑MY에서 확인하세요!',
}

export const defaultOgTag: OgTag = {
  title: '네이버쇼핑',
  imageUrl: 'https://ssl.pstatic.net/static.checkout/cnsv/m/im/snippet/snippet_shopping.png',
  description: '네이버쇼핑',
}

export const mobileMainOgTag: OgTag = {
  title: '네이버 모바일 메인',
  imageUrl: `${process.env.PUBLIC_URL}snippet_main.png`,
  description: '네이버 모바일 메인',
}
